export default function displayArrayAsString(values) {
  if (!values?.length) {
    return "-";
  }

  return values.join(", ");
}
